// extracted by mini-css-extract-plugin
export default {"container":"search__container__ArwUt","resultsListWrapper":"search__resultsListWrapper__YKUnw","resultsPanel":"search__resultsPanel__A4RTa"};